import { RegExpUtility } from "../text/RegExpUtility";
import { DateMath } from "./DateMath";

export class DateHelper
{
  static now()
  {
    let date = new Date();

    return date;
  }

  static today()
  {
    let date = new Date();
    date.setHours( 0, 0, 0 );

    return date;
  }

  static clockTime( date:Date )
  {
    return RegExpUtility.minimumDigitsInt( date.getHours(), 2 ) + ":" +  RegExpUtility.minimumDigitsInt( date.getMinutes(), 2 );
  }

  static dateOnly( date:Date )
  {
    return RegExpUtility.minimumDigitsInt( date.getDay() ) + "." +  
           RegExpUtility.minimumDigitsInt( date.getMonth() ) + ".";
  }

  static smartTime( date:Date )
  {
    if ( DateMath.isToday( date ) )
    {
      return this.clockTime( date );
    }

    return this.clockTime( date ) + " " + this.dateOnly( date );
  }

  static createYMD( year:number, month:number = 1, day:number = 1, hours:number = 0, minutes:number = 0, seconds:number = 0  )
  {
    let date = new Date();
    
    date.setFullYear( year );
    date.setMonth( month - 1 );
    date.setDate( day );
    date.setHours( hours, minutes, seconds );

    return date;
  }
}